module.exports = __webpack_public_path__ + "img/logo_header_white.89d307f9.png";